import React from 'react';
import {
  Box,
  Typography,
  useTheme,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import ReactResizeDetector from 'react-resize-detector';
import {
  Column,
  Table,
  TableHeaderRowProps,
  TableRowProps,
} from 'react-virtualized';
import classNames from 'classnames';
import clsx from 'clsx';
import PopupDialog from '../../../../components/popupDialog';

import {
  ResultDetailsDispatchFunc,
  ResultDetailsInfo,
} from '../types';

import styles from './TestListPopup.styles';
import { RequestOrderInfo } from '../../result/types';

type Props = {
  resultDetails?: ResultDetailsInfo;
  testListPopup: {
    isOpen: boolean;
  };
  closeTestListPopup: ResultDetailsDispatchFunc<unknown>;
};

const useStyles = makeStyles(styles);
const TestListPopup: React.FC<Props> = ({
  resultDetails,
  testListPopup: {
    isOpen,
  },
  closeTestListPopup,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  const paramList = resultDetails?.requestInfo.testOrder || [];

  const arrangeOrder: RequestOrderInfo[] = [];

  paramList.forEach((val) => {
    if (val.type === 'normal') {
      arrangeOrder.push(val);
    } else {
      arrangeOrder.push(val);
      val.packageDetails?.forEach((pack) => {
        arrangeOrder.push({
          ...pack,
          name: ` - ${pack.name}`,
        });
      });
    }
  });

  // const arrangeOrder =

  const headerRowRenderer = ({
    columns,
    style,
  }: TableHeaderRowProps) => (
    <Box
      className={classes.tableHeaderRow}
      role="row"
      style={style}
    >
      {columns}
    </Box>
  );

  const rowRenderer = ({
    key,
    columns,
    style,
    index,
  }: TableRowProps) => (
    <Box
      key={key}
      className={
        classNames(
          index % 2 === 0 ? classes.tableEvenRow : classes.tableOddRow,
          classes.tableHover,
        )
      }
      role="row"
      style={style}
    >
      {columns}
    </Box>
  );

  return (
    <PopupDialog
      open={isOpen}
      title="Test List"
      closeAction={closeTestListPopup}
      maxWidth="md"
      classes={{
        content: classes.root,
      }}
    >
      <Box className={classes.details}>
        <ReactResizeDetector handleHeight handleWidth>
          {({ width, height }) => (
            <Table
              height={(height || 0) - 8 || 0}
              width={width || 0}
              rowCount={arrangeOrder.length}
              rowGetter={({ index }) => arrangeOrder[index]}
              rowHeight={theme.spacing(4)}
              headerHeight={theme.spacing(4)}
              headerRowRenderer={headerRowRenderer}
              headerClassName={classNames(
                classes.tableHeaderCell,
              )}
              gridClassName={classes.tableGrid}
              rowRenderer={rowRenderer}
              className={classes.table}
            >
              <Column
                label="Test"
                cellDataGetter={({ rowData }) => (rowData as RequestOrderInfo).name}
                dataKey="name"
                width={600}
                className={classes.tableCell}
              />
              <Column
                label="Status"
                cellDataGetter={({ rowData }) => (rowData as RequestOrderInfo).status}
                dataKey="status"
                width={200}
                className={classes.tableCell}
                cellRenderer={({ cellData }) => (
                  <Typography
                    className={clsx({
                      [classes.orderCancelled]: cellData === 'cancelled',
                      [classes.orderProcess]: cellData === 'process',
                      [classes.orderComplete]: cellData === 'complete',
                    })}
                    component="span"
                    color="inherit"
                    variant="body2"
                    align="center"
                  >
                    {cellData}
                  </Typography>
                )}
              />
              <Column
                label="Flag"
                cellDataGetter={({ rowData }) => (rowData as RequestOrderInfo).flag}
                dataKey="status"
                width={200}
                className={classes.tableCell}
                cellRenderer={({ rowData, cellData }) => (
                  <Typography
                    className={clsx({
                      [classes.orderComplete]: (rowData as RequestOrderInfo).status === 'complete' && !cellData,
                      [classes.orderAbnormal]: (rowData as RequestOrderInfo).status === 'complete' && cellData,
                    })}
                    component="span"
                    color="inherit"
                    variant="body2"
                    align="center"
                  >
                    {(rowData as RequestOrderInfo).status === 'complete' && (!cellData ? 'Normal' : 'Abnormal')}
                  </Typography>
                )}
              />
            </Table>
          )}
        </ReactResizeDetector>
      </Box>
    </PopupDialog>
  );
};

export default TestListPopup;
